var e = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M11.62 16l2.45-2.02L9.9 9.03 16 7.3l-1-3.11-5.8 2.46L9.6 0H6.4l.38 6.65L1 4.19l-1 3.1 6.07 1.74-4.17 4.95L4.35 16 8 10.47z", "fill-rule": "nonzero" } }] }, name: "required", theme: "outlined" };
export {
  e as default
};
